var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"add-btn-wrapper d-flex align-center justify-center"},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("$vuetify.icons.plus")])],1),_vm._v(" "),_c('span',{staticClass:"ml-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }